module.exports = __webpack_public_path__ + "static/media/Mapa-Paraíba.2cfb5a99.svg";